import React from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const HomePage = () => {
  const { user } = useUser();

  return (
    <div className="space-y-12">
      {/* 英雄区块 */}
      <section className="cyber-panel p-8 md:p-12 rounded-lg text-center relative overflow-hidden">
        <div className="relative z-10">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-xianxia text-cyber-primary mb-6 cyber-title glowing-text">
            天道宗 - 赛博修仙
          </h1>
          <p className="text-xl md:text-2xl font-cyber text-cyber-light mb-8 max-w-3xl mx-auto">
            传统仙侠与现代科技的完美结合，踏上数字化修真之路
          </p>
          
          <div className="flex flex-wrap justify-center gap-4">
            {user ? (
              <Link to="/cultivation" className="cyber-button text-lg px-8 py-3">
                开始修炼
              </Link>
            ) : (
              <>
                <Link to="/register" className="cyber-button text-lg px-8 py-3">
                  加入宗门
                </Link>
                <Link to="/login" className="cyber-button text-lg px-8 py-3">
                  道友登录
                </Link>
              </>
            )}
          </div>
        </div>
        
        {/* 背景效果 */}
        <div className="absolute top-0 left-0 w-full h-full bg-cyber-gradient opacity-10"></div>
      </section>

      {/* 特色功能区块 */}
      <section className="py-8">
        <h2 className="text-3xl font-xianxia text-cyber-primary text-center mb-12 cyber-title">
          赛博修真体系
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* 修炼系统 */}
          <div className="cyber-panel p-6 rounded-lg hover:shadow-cultivation transition-all duration-300 hover:-translate-y-2">
            <div className="text-3xl text-cyber-accent mb-4">
              <i className="fas fa-spa"></i>
            </div>
            <h3 className="text-xl font-cyber text-cyber-secondary mb-3">数字化修炼系统</h3>
            <p className="text-cyber-light mb-4">
              结合现代生物指标与古老修真理论，通过数字化手段跟踪您的修炼进度，提升体魄与精神力量。
            </p>
            <Link to="/cultivation" className="cyber-button inline-block">
              了解更多
            </Link>
          </div>
          
          {/* 炼器系统 */}
          <div className="cyber-panel p-6 rounded-lg hover:shadow-cultivation transition-all duration-300 hover:-translate-y-2">
            <div className="text-3xl text-cyber-accent mb-4">
              <i className="fas fa-hammer"></i>
            </div>
            <h3 className="text-xl font-cyber text-cyber-secondary mb-3">赛博炼器系统</h3>
            <p className="text-cyber-light mb-4">
              将传统法器概念与现代设备结合，炼制具有特殊功能的赛博法器，如数字化加湿器葫芦、能量转换器等。
            </p>
            <Link to="/artifact-refining" className="cyber-button inline-block">
              了解更多
            </Link>
          </div>
          
          {/* 功德点系统 */}
          <div className="cyber-panel p-6 rounded-lg hover:shadow-cultivation transition-all duration-300 hover:-translate-y-2">
            <div className="text-3xl text-cyber-accent mb-4">
              <i className="fas fa-coins"></i>
            </div>
            <h3 className="text-xl font-cyber text-cyber-secondary mb-3">功德点 - 宗门数字货币</h3>
            <p className="text-cyber-light mb-4">
              基于区块链技术的宗门数字货币，完成任务获取功德点，兑换修炼资源、法器和特殊服务。
            </p>
            <Link to="/virtual-currency" className="cyber-button inline-block">
              了解更多
            </Link>
          </div>
        </div>
      </section>
      
      {/* 特色服务 */}
      <section className="py-8">
        <h2 className="text-3xl font-xianxia text-cyber-primary text-center mb-12 cyber-title">
          特色服务
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* 占卜系统 */}
          <div className="cyber-panel p-6 rounded-lg flex items-start space-x-4">
            <div className="text-2xl text-cyber-accent">
              <i className="fas fa-star"></i>
            </div>
            <div>
              <h3 className="text-xl font-cyber text-cyber-secondary mb-2">数字化占卜系统</h3>
              <p className="text-cyber-light mb-3">
                结合传统占卜理论与现代数据分析，提供个性化的命运预测和发展指导。
              </p>
              <Link to="/divination" className="text-cyber-primary hover:text-cyber-accent transition duration-300">
                探索占卜系统 →
              </Link>
            </div>
          </div>
          
          {/* 端粒检测 */}
          <div className="cyber-panel p-6 rounded-lg flex items-start space-x-4">
            <div className="text-2xl text-cyber-accent">
              <i className="fas fa-dna"></i>
            </div>
            <div>
              <h3 className="text-xl font-cyber text-cyber-secondary mb-2">端粒长度检测</h3>
              <p className="text-cyber-light mb-3">
                通过分析DNA端粒长度，评估您的生物学年龄和潜在寿命，制定个性化修炼计划。
              </p>
              <Link to="/telomere-testing" className="text-cyber-primary hover:text-cyber-accent transition duration-300">
                了解寿命检测 →
              </Link>
            </div>
          </div>
          
          {/* AR法器展示 */}
          <div className="cyber-panel p-6 rounded-lg flex items-start space-x-4">
            <div className="text-2xl text-cyber-accent">
              <i className="fas fa-vr-cardboard"></i>
            </div>
            <div>
              <h3 className="text-xl font-cyber text-cyber-secondary mb-2">AR法器展示</h3>
              <p className="text-cyber-light mb-3">
                通过增强现实技术，查看和体验各种赛博法器的功能和效果，辅助修炼和日常生活。
              </p>
              <Link to="/ar-view" className="text-cyber-primary hover:text-cyber-accent transition duration-300">
                体验AR展示 →
              </Link>
            </div>
          </div>
          
          {/* 任务系统 */}
          <div className="cyber-panel p-6 rounded-lg flex items-start space-x-4">
            <div className="text-2xl text-cyber-accent">
              <i className="fas fa-tasks"></i>
            </div>
            <div>
              <h3 className="text-xl font-cyber text-cyber-secondary mb-2">修真任务系统</h3>
              <p className="text-cyber-light mb-3">
                结合现实技能提升与修真理念，完成各种任务获取经验和功德点，提升自身境界。
              </p>
              <Link to="/quest-system" className="text-cyber-primary hover:text-cyber-accent transition duration-300">
                查看任务系统 →
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* 弟子展示 */}
      <section className="py-8">
        <h2 className="text-3xl font-xianxia text-cyber-primary text-center mb-12 cyber-title">
          杰出弟子
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="cyber-panel p-5 rounded-lg text-center">
              <div className="w-24 h-24 rounded-full border-2 border-cyber-primary mx-auto mb-4 overflow-hidden">
                <img 
                  src={`https://randomuser.me/api/portraits/${i % 2 === 0 ? 'women' : 'men'}/${i + 20}.jpg`} 
                  alt="弟子头像" 
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="text-lg font-cyber text-cyber-secondary mb-1">
                云霄道友 {i}
              </h4>
              <p className="text-sm text-cyber-accent mb-2">
                {['金丹期', '元婴期', '炼神期', '炼虚期'][i - 1]}
              </p>
              <p className="text-xs text-cyber-light">
                「{['数据凝练，化为真我', '赛博之道，道法自然', '数字与灵气，相辅相成', '编码乾坤，运算天道'][i - 1]}」
              </p>
            </div>
          ))}
        </div>
      </section>
      
      {/* 加入我们 */}
      <section className="cyber-panel p-8 md:p-12 rounded-lg text-center">
        <h2 className="text-3xl font-xianxia text-cyber-primary mb-6 cyber-title">
          加入天道宗
        </h2>
        <p className="text-lg text-cyber-light mb-8 max-w-3xl mx-auto">
          无论您是科技爱好者、传统文化研究者，还是寻求自我提升的修行者，天道宗都欢迎您的加入。开启赛博修真之旅，探索科技与传统的完美融合。
        </p>
        
        <Link to="/register" className="cyber-button text-lg px-8 py-3">
          立即注册
        </Link>
      </section>
    </div>
  );
};

export default HomePage;
